import styled from 'styled-components';

export const SwitchGroupRightWrapper = styled.div<{ $alignItems?: string }>`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    gap: 10px;
    margin-right: 5px;
`;
